import { useFeatureFlag, getFeatureFlagValue } from './useFeatureFlag'

/** React hook — use inside components to check if UI v2 (Intui) is enabled */
export function useUIv2(): boolean {
  return useFeatureFlag('VITE_UIV2')
}

/** Synchronous check — use at module scope in ui/*.tsx for conditional exports */
export function isUIv2(): boolean {
  return getFeatureFlagValue('VITE_UIV2')
}
